function isAssetInLocalStorage(localAsset, file) {
  if (!localAsset) {
    return false;
  }

  const { filename, lastModified, metaData } = localAsset;
  const { size: fileSize } = JSON.parse(metaData);

  return filename === file.name &&
  fileSize === file.size &&
  lastModified === file.lastModified;
}

export default isAssetInLocalStorage;